import clsx from "clsx";
import { useTranslation, TranslationProvider, useLocale } from "rujira.ui";
import { PageIntro } from "../common/components/PageIntro";
import { useIsMobile } from "../hooks/useBreakpoint";
import { Debts } from "../liquidate/Debts";
import { getStaticProductSeo, ProductSeoHelmet } from "../seo";

export function Lending() {
  const { locale } = useLocale();

  return (
    <TranslationProvider namespace="lending">
      <ProductSeoHelmet seo={getStaticProductSeo("/lend", locale)} />
      <LendingContent />
    </TranslationProvider>
  );
}

function LendingContent() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const Description = t("description");

  return (
    <>
      <div className="rujira__main rujira__main--gradient lending">
        <div className="rujira__inner--pad rujira__inner--pad-tight">
          <div className="rujira__inner">
            <h1 className="h1">{t("title")}</h1>
            <PageIntro className="fs-20 lh-28 mw-md-100 balance">
              {Description}
            </PageIntro>
            <div className="flex dir-c gap-2">
              <div className={clsx("relative mt-4", { "card p-3": !isMobile })}>
                <Debts />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
